import { Checkbox, Spin } from 'antd'
import { useEffect, useState } from 'react'
import { useHttp } from '../hooks/http.hook'
import { Button } from './Button'
import { OrderLayout } from './OrderLayout'
import { ProductInstruction } from './ProductInstruction'
import { ShopFollow } from './ShopFollow'

const normalizeOptions = (options) => {
  if (!options) return []
  return Array.isArray(options) ? options : [options]
}

const FieldInput = ({ field, value, onChange }) => {
  const validation = field.validation || {}
  const commonClass = 'bg-[#1E1F23] w-full border border-[#8F8F96] rounded-lg px-3 py-2 text-white'

  if (field.type === 'list') {
    return (
      <select
        className={commonClass}
        value={value || ''}
        onChange={(event) => onChange(event.target.value)}
      >
        <option value=''>Выберите значение</option>
        {normalizeOptions(field.options).map((option) => (
          <option key={String(option.value)} value={option.value}>
            {option.label || option.value}
          </option>
        ))}
      </select>
    )
  }

  const isNumber = field.type === 'integer' || field.type === 'decimal'

  return (
    <input
      className={commonClass}
      type={isNumber ? 'number' : 'text'}
      step={field.type === 'integer' ? '1' : field.type === 'decimal' ? 'any' : undefined}
      min={isNumber && validation.min !== null ? validation.min : undefined}
      max={isNumber && validation.max !== null ? validation.max : undefined}
      minLength={!isNumber && validation.min !== null ? validation.min : undefined}
      maxLength={!isNumber && validation.max !== null ? validation.max : undefined}
      pattern={!isNumber ? validation.pattern || undefined : undefined}
      value={value || ''}
      onChange={(event) => onChange(event.target.value)}
    />
  )
}

const FieldValue = ({ label, value }) => {
  if (value === undefined || value === null || value === '') return null

  return (
    <div className='order-field-value'>
      <span>{label}:</span>
      <span className='text-white break-all text-right'>{String(value)}</span>
    </div>
  )
}

export const DTUOrder = ({ orders, code, onCompleted, messageContent }) => {
  const { request, loading } = useHttp()
  const [values, setValues] = useState(orders?.values || {})
  const [confirmation, setConfirmation] = useState(false)
  const [serverMessage, setServerMessage] = useState('')

  useEffect(() => {
    setValues(orders?.values || {})
  }, [orders])

  if (!orders) return messageContent

  const fields = Array.isArray(orders.fields) ? orders.fields : []

  const submit = async () => {
    if (!confirmation) {
      setServerMessage('Подтвердите правильность введённых данных.')
      return
    }

    const missingField = fields.find((field) => field.required && !String(values[field.key] || '').trim())
    if (missingField) {
      setServerMessage(`Заполните поле «${missingField.label || missingField.key}».`)
      return
    }

    try {
      setServerMessage('')
      const response = await request('/api/order/extingDTUOrder', 'POST', { code, values })
      setServerMessage(response.message || '')
      if (response.status && response.purchase) onCompleted(response.purchase)
    } catch (error) {
      setServerMessage(error.message)
    }
  }

  return <OrderLayout orders={orders} kind='DTU' complete={Boolean(orders.completed)}
    title={orders.orderName || orders.serviceName}
    status={orders.completed ? 'Выполнен' : 'Ожидает данных'}
    dateLabel={orders.completed ? 'Дата выполнения' : 'Дата заказа'}
    extra={{ label: 'Игра', value: orders.serviceName }}
    facts={orders.providerOrderId ? [{ label: 'ID пополнения', value: orders.providerOrderId }] : []}
    after={<>
      <ProductInstruction title='Как получить игровое пополнение' hint='Данные аккаунта и порядок получения — в инструкции.' html={orders.issue_instruction} />
      {orders.completed && <ShopFollow />}
    </>}>
    {!orders.completed ? <div className='order-form'>
      <h2 className='order-result-title'>Укажите данные для пополнения</h2>
      {fields.map((field) => <label key={field.key} className='flex flex-col gap-2'>
        <span>{field.label || field.key}{field.required ? ' *' : ''}</span>
        <FieldInput field={field} value={values[field.key]} onChange={(value) => setValues((previous) => ({ ...previous, [field.key]: value }))} />
        {field.validation?.message && <span className='order-note'>{field.validation.message}</span>}
      </label>)}
      {!fields.length && <div className='text-red-300 text-center'>Поля этого DTU-товара не настроены.</div>}
      <Checkbox checked={confirmation} onChange={(event) => setConfirmation(event.target.checked)} className='text-white'>Подтверждаю, что данные указаны верно. После пополнения их нельзя изменить.</Checkbox>
      {serverMessage && <div role='status' className='order-note'>{serverMessage}</div>}
      <Button type='primary' color='purple' size='md' disabled={loading || !fields.length} onClick={submit}>{loading ? <Spin /> : 'ПОПОЛНИТЬ'}</Button>
    </div> : <div>
      <h2 className='order-result-title'>Пополнение успешно выполнено</h2>
      {fields.map((field) => <FieldValue key={field.key} label={field.label || field.key} value={orders.values?.[field.key] || orders.attributes?.[field.key]} />)}
    </div>}
  </OrderLayout>
}
